export const DetailCard = (props) => {
  const {
    data,
    label,
    width = "w-80",
    showSub = false,
    style = {},
    height,
  } = props || {};

  function truncateText(text, maxLength) {
    if (text.length <= maxLength) return text;
    return text.substr(0, maxLength) + '...';
  }
  
  // const originalText = 'Here is some long text that needs to be truncated after 200 characters. Add more text to see the effect.';
  // const truncatedText = truncateText(originalText, 200);
  
  return (
    <div
      className={`border rounded-lg shadow-100 p-6 md:mr-4 lg:mr-6 sm:mr-2 my-3 ${width} ${height}`}
      style={style}
    >
      <span className="text-xl font-semibold text-gray-900 mt-4">{label}</span>
      {showSub && (
        <p className="font-semibold text-gray-700 mt-2">
          Please contact the Trial Administrator with any questions about this
          trial.
        </p>
      )}
      <hr className="mt-4" />
      <div className="mb-4" />
      {data.map((detail, index) => (
        <div key={detail.value} className="flex flex-row mt-3">
          {detail?.isMainHeading ? <></> : detail.icon}
          <span
            className={`${
              detail?.isMainHeading
                ? " text-lg font-bold text-gray-900"
                : "ml-2 max-w-lg break-words overflow-hidden text-base font-medium text-gray-700"
            }`}
          >
            {truncateText (detail.value , 60)}
          </span>
        </div>
      ))}
    </div>
  );
};
